import { render } from "./Notifications.vue?vue&type=template&id=71aa57c4"
import script from "./Notifications.vue?vue&type=script&lang=js"
export * from "./Notifications.vue?vue&type=script&lang=js"

import "./Notifications.vue?vue&type=style&index=0&id=71aa57c4&lang=css"

import exportComponent from "/Users/ergishoxha/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__